import React from 'react';
import { COVER_BG_IMAGE, COVER_OVERLAY } from '../constants/cover';

/**
 * Couverture de page unifiée (thème ligue) : bandeau hero avec image de fond terrain/stade,
 * overlay bleu léger pour lisibilité. Utilisée sur Liens utiles, Communiqués, Résultats, etc.
 */
const PageCover = ({ title, subtitle, icon: Icon, backgroundImage }) => {
  const bgImage = backgroundImage || COVER_BG_IMAGE;
  return (
    <header
      style={{
        ...styles.cover,
        backgroundImage: `${COVER_OVERLAY}, url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div style={styles.content}>
        {Icon && <Icon style={styles.icon} />}
        <h1 style={styles.title}>{title}</h1>
        {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
      </div>
    </header>
  );
};

const styles = {
  cover: {
    width: '100%',
    padding: 'clamp(40px, 8vw, 70px) 16px',
    textAlign: 'center',
    color: 'white',
    boxSizing: 'border-box'
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    width: '100%'
  },
  icon: {
    fontSize: 'clamp(40px, 8vw, 56px)',
    marginBottom: '16px',
    opacity: 0.95
  },
  title: {
    fontSize: 'clamp(26px, 5vw, 40px)',
    fontWeight: 'bold',
    marginBottom: '12px'
  },
  subtitle: {
    fontSize: 'clamp(14px, 2.2vw, 18px)',
    opacity: 0.95,
    lineHeight: 1.5
  }
};

export default PageCover;
